import { h, FunctionComponent } from 'preact';
import groupBy from 'lodash/groupBy';
import keys from 'lodash/keys';
import { Image } from '../types';

const ZoomButtons: FunctionComponent<ZoomButtonsProps> = ({ images, selectedColour, onSelect }) => {
    // group the available images by colour to create picture elements
    const groupedByColour = groupBy(images, (i: Image) => i.colour);
    const colours: string[] = keys(groupedByColour),
        currentColourIdx = colours.indexOf(selectedColour),
        nextColour = colours[currentColourIdx + 1],
        previousColour = colours[currentColourIdx - 1];

    return (
        <div>
            <button
                type="button"
                onClick={() => onSelect(previousColour)}
                class="zoom-modal__button-previous"
                disabled={previousColour === undefined}
            >
                <span class="sr-only">Previous</span>
            </button>
            <button
                type="button"
                onClick={() => onSelect(nextColour)}
                class="zoom-modal__button-next"
                disabled={nextColour === undefined}
            >
                <span class="sr-only">Next</span>
            </button>
        </div>
    );
};

interface ZoomButtonsProps {
    images: Image[];
    selectedColour: string;
    onSelect: (colour: string) => void;
}

export default ZoomButtons;
